// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
import * as fm from "../../../../fetch.pb.js";
/**
 * FaxDraftService provides all the methods needed to manage fax drafts.
 */
export const FaxDraftService = {
    StartDraft(fn, req) {
        return fn(`/fax/draft/v1/drafts`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    GetDraft(fn, req) {
        try {
            fm.validateUrlParam(req["draftId"], "draftId");
        }
        catch (e) {
            return Promise.reject(e);
        }
        return fn(`/fax/draft/v1/drafts/${req["draftId"]}?${fm.renderURLSearchParams(req, ["draftId"])}`, { method: "GET" });
    },
    GetDraftCount(fn, req) {
        return fn(`/fax/draft/v1/drafts/count?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    ListDrafts(fn, req) {
        return fn(`/fax/draft/v1/drafts?${fm.renderURLSearchParams(req, [""])}`, { method: "GET" });
    },
    /**
     * Populates the draft coversheet html with a copy of the template html and populates
     * the coversheet template id for reference.
     */
    UpdateCoversheetHtmlFromTemplate(fn, req) {
        return fn(`/fax/draft/v1/drafts/template-coversheet-html`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Handle ad-hoc draft coversheet user updates. The provided html supplants the previous
     * html.
     * Coversheet html updates only update the html. The coversheet draft is not rendered to a pdf
     * media file.
     */
    UpdateCoversheetHtml(fn, req) {
        return fn(`/fax/draft/v1/drafts/coversheet-html`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    UnsetCoversheetHtml(fn, req) {
        return fn(`/fax/draft/v1/drafts/clear-coversheet-html`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    /**
     * Will render the coversheet html by converting it to a PDF. The optional contact id
     * must be a contact that has already been added to the fax draft "recipients" list.
     */
    RenderCoversheet(fn, req) {
        return fn(`/fax/draft/v1/drafts/render-coversheet`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    SetCoversheetUploadedFile(fn, req) {
        return fn(`/fax/draft/v1/drafts/uploaded-coversheet-file`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    UnsetCoversheetUploadedFile(fn, req) {
        return fn(`/fax/draft/v1/drafts/clear-uploaded-coversheet-file`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    SetUploadedFiles(fn, req) {
        return fn(`/fax/draft/v1/drafts/uploaded-files`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    MergeUploadedFiles(fn, req) {
        return fn(`/fax/draft/v1/drafts/merge-uploaded-files`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    AddRecipient(fn, req) {
        return fn(`/fax/draft/v1/drafts/add-recipient`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    AddRecipientByFaxNumber(fn, req) {
        return fn(`/fax/draft/v1/drafts/add-recipient-by-fax-number`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    RemoveRecipient(fn, req) {
        return fn(`/fax/draft/v1/drafts/remove-recipient`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    SetLocationFaxPhone(fn, req) {
        return fn(`/fax/draft/v1/drafts/location-fax-phone`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    MergeFinal(fn, req) {
        return fn(`/fax/draft/v1/drafts/merge-final`, { method: "PATCH", body: JSON.stringify(req, fm.replacer) });
    },
    SendFromDraft(fn, req) {
        return fn(`/fax/draft/v1/drafts/send`, { method: "POST", body: JSON.stringify(req, fm.replacer) });
    },
    DeleteDraft(fn, req) {
        return fn(`/fax/draft/v1/faxes?${fm.renderURLSearchParams(req, [""])}`, { method: "DELETE" });
    },
};
